export default __webpack_public_path__ + "static/media/Thesis-amico.4f4acc0e.svg";